<template>
  <div class="body-box">
    <!-- 搜索与添加区域 -->
    <el-row class="plan">
      <el-col :span="24">
        <el-button @click="addDialog" icon="el-icon-plus">新增</el-button>
      </el-col>
    </el-row>

    <!-- 用户列表区域 -->
    <el-table :height="'calc(100% - 70px)'" :data="rolesList" class="button-box">
      <el-table-column type="index" width="80px" label="序号"></el-table-column>
      <el-table-column label="角色名称" prop="name"></el-table-column>
      <el-table-column label="关键字" prop="keyword"></el-table-column>
      <el-table-column label="角色描述" prop="describe"></el-table-column>
      <el-table-column label="时间" prop="createDatetime">
        <template slot-scope="scope">
          {{ scope.row.createDatetime | formatDate }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180px">
        <template slot-scope="scope">
          <!-- 修改按钮 -->
          <el-button icon="el-icon-edit" @click="showEditDialog(scope.row)">修改</el-button>
          <!-- 删除按钮 -->
          <el-button icon="el-icon-delete" @click="removeUserById(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加角色对话框 -->
    <el-dialog
      title="添加角色"
      :visible.sync="addDialogVisible"
      width="40%"
      class="dialogBox"
      @close="addDialogClosed"
    >
      <!-- 内容主体区域 -->
      <el-form
        ref="addFormRef"
        :model="addForm"
        label-width="100px"
        :rules="rules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="角色名称" prop="name">
              <el-input v-model="addForm.name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="关键字" prop="keyword">
              <el-input v-model="addForm.keyword"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="角色描述" prop="describe">
              <el-input v-model="addForm.describe" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="分配权限">
              <el-tree
                :data="rightsList"
                :props="treeProps"
                show-checkbox
                node-key="id"
                :default-checked-keys="defkeys"
                ref="treeRef"
              ></el-tree>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addRoles">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改角色对话框 -->
    <el-dialog title="修改角色" class="dialogBox" :visible.sync="editDialogVisible" width="40%">
      <!-- 内容主体区域 -->
      <el-form
        ref="editFormRef"
        :model="editForm"
        :rules="rules"
        label-width="100px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="角色名称" prop="name">
              <el-input v-model="editForm.name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="关键字" prop="keyword">
              <el-input v-model="editForm.keyword"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="角色描述" prop="describe">
              <el-input v-model="editForm.describe" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="分配权限">
              <el-tree
                :data="rightsList"
                :props="treeProps"
                show-checkbox
                node-key="id"
                :default-checked-keys="defkey"
                ref="treeRefs"
              ></el-tree>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editRolesInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { roleRules } from '@/js/rules'
import { listMenu } from '@/api/user/menu/menu'
import { deleteRolesById, postRolesList, rolesList } from '@/api/user/users/users'
import { getData, getPostOrDeleteData } from '@/utils/code'

export default {
  data() {
    return {
      query: '',
      rightsList: [], //权限分配
      rolesList: [],
      loading: false,
      addForm: {
        keyword: '', //权限字符
        name: '', // 角色
        describe: '' //说明
      },
      queryInfo: {
        current: 1,
        size: 1000
      },
      // 查询到的用户信息对象
      editForm: {
        keyword: '', //权限字符
        name: '', // 角色
        describe: '' //说明
      },
      addDialogVisible: false,
      editDialogVisible: false,
      // 树形控件的属性绑定对象
      treeProps: {
        label: 'name',
        children: 'menuChildList'
      },
      // 默认选中的节点id值数组
      defkeys: [],
      defkey: [],
      rules: roleRules,
      // 当前即将分配权限的角色id
      roleId: ''
    }
  },
  created() {
    this.getRolesList()
  },
  methods: {
    // 点击新增
    addDialog() {
      this.addDialogVisible = true
      this.getMenuList()
    },

    // 获取菜单列表
    getMenuList() {
      listMenu(this.queryInfo).then(res => {
        this.rightsList = res.data.records
      })
    },

    // 获取用户列表
    getRolesList() {
      rolesList().then(res => {
        this.rolesList = res.data
      })
    },

    // 添加角色
    addRoles() {
      let arrs = this.$refs.treeRef.getCheckedKeys()
      this.addForm.menuList = arrs
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        postRolesList(this.addForm).then(res => {
          let data = getData(res)
          if (data !== null) {
            this.getRolesList()
          }
        })
        this.addDialogVisible = false
      })
    },

    // 删除角色
    async removeUserById(id) {
      await this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: async (action) => {
          if (action === 'confirm') {
            deleteRolesById(id).then(res => {
              let data = getPostOrDeleteData(res)
              if (data !== null) {
                this.getRolesList()
              }
            })
          }
        }
      })
    },

    // 监听添加用户对话框的关闭事件 /  重置表单
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
    },

    // 修改角色
    showEditDialog(row) {
      this.getMenuList()
      this.editForm = JSON.parse(JSON.stringify(row))
      this.defkey = row.menuList
      this.editDialogVisible = true
    },

    // 修改角色
    editRolesInfo() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        let param = {
          keyword: this.editForm.keyword,
          name: this.editForm.name,
          describe: this.editForm.describe,
          id: this.editForm.id
        }
        param.menuList = this.$refs.treeRefs.getCheckedKeys()
        postRolesList(param).then(res => {
          let data = getData(res)
          if (data !== null) {
            this.editDialogVisible = false
            this.getRolesList()
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.el-input {
  margin: 0 5px;
}
</style>
